(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const descriptionElements = document.querySelectorAll('[data-description]');

    descriptionElements.forEach((descriptionEl) => {
      const seeMoreBtn = descriptionEl.parentElement.querySelector('[data-see-more]');

      if (!seeMoreBtn) return;

      // Check if content is overflowing (more than 4.5rem height ~= 3 lines)
      const contentHeight = descriptionEl.scrollHeight;
      const maxHeight = 72; // 4.5rem = 72px

      // If content is taller than max height, show "Leer más" button
      if (contentHeight > maxHeight) {
        seeMoreBtn.classList.remove('hide');
      } else {
        // If content fits, remove the reduced-intro class
        descriptionEl.classList.remove('reduced-intro');
        seeMoreBtn.classList.add('hide');
      }

      // Toggle expansion
      seeMoreBtn.addEventListener('click', () => {
        const isExpanded = descriptionEl.classList.contains('expanded');

        if (isExpanded) {
          descriptionEl.classList.remove('expanded');
          seeMoreBtn.textContent = 'Leer más';
        } else {
          descriptionEl.classList.add('expanded');
          seeMoreBtn.textContent = 'Leer menos';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-custom-ifdesign"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.cachedResults = {};
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.isOpen = false;
        this.abortController = new AbortController();
        this.searchTerm = '';

        this.setupEventListeners();
      }

      setupEventListeners() {
        const form = this.querySelector('form');
        form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));

        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      getQuery() {
        return this.input.value.trim();
      }

      onChange() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) {
          this.close(true);
          return;
        }

        this.searchTerm = searchTerm;
        this.getSearchResults(searchTerm);
      }

      onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
          event.preventDefault();
        }
      }

      onFocus() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) return;

        if (this.searchTerm !== searchTerm) {
          this.getSearchResults(searchTerm);
        } else {
          this.open();
        }
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();

        switch (event.code) {
          case 'ArrowUp':
            this.switchOption('up');
            break;
          case 'ArrowDown':
            this.switchOption('down');
            break;
          case 'Enter':
            this.selectOption();
            break;
        }
      }

      onKeydown(event) {
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
          event.preventDefault();
        }
      }

      switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allElements = this.querySelectorAll('li');
        let activeElement = this.querySelector('li');

        if (moveUp && !selectedElement) return;

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
          activeElement = selectedElement.nextElementSibling || allElements[0];
        } else if (moveUp) {
          activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
        }

        if (activeElement === selectedElement) return;

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', activeElement.id);
      }

      selectOption() {
        const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

        if (selectedProduct) selectedProduct.click();
      }

      getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(' ', '-').toLowerCase();
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
          this.renderSearchResults(this.cachedResults[queryKey]);
          return;
        }

        this.abortController.abort();
        this.abortController = new AbortController();

        fetch(`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`, {
          signal: this.abortController.signal
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.cachedResults[queryKey] = resultsMarkup;
            this.renderSearchResults(resultsMarkup);
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            this.close();
            throw error;
          });
      }

      setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
      }

      setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
          this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
      }

      renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);

        this.setLiveRegionResults();
        this.open();
      }

      setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]')?.textContent || '');
      }

      open() {
        this.setAttribute('open', true);
        this.isOpen = true;
      }

      close(clearSearchTerm = false) {
        if (clearSearchTerm) {
          this.input.value = '';
          this.removeAttribute('results');
        }

        const selected = this.querySelector('[aria-selected="true"]');

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('open');
        this.isOpen = false;
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    });
  }

  // Sticky header with background change on scroll
  (() => {
    const headerSection = document.querySelector('header.shopify-section');
    const headerElement = document.querySelector('header .header');
    let isScrolled = false;
    let ticking = false;

    function updateHeader() {
      const shouldBeScrolled = window.scrollY > 50;
      if (shouldBeScrolled !== isScrolled) {
        isScrolled = shouldBeScrolled;
        if (isScrolled) {
          if (headerSection) headerSection.classList.add('scrolled');
          if (headerElement) headerElement.classList.add('scrolled');
        } else {
          if (headerSection) headerSection.classList.remove('scrolled');
          if (headerElement) headerElement.classList.remove('scrolled');
        }
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  })();

  // Mobile menu - Full screen version
  document.addEventListener('DOMContentLoaded', () => {
    const burgerToggle = document.getElementById('burger-toggle');
    const navbar = document.querySelector('.navbar');
    const menuOverlay = document.querySelector('[data-menu-overlay]');
    const submenuTogglers = document.querySelectorAll('.plus-minus-toggler');
    const isMobile = () => window.innerWidth < 1024;

    // Helper function to close mobile menu
    function closeMobileMenu() {
      if (burgerToggle) burgerToggle.checked = false;
      if (navbar) navbar.classList.remove('open');
      if (menuOverlay) menuOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    // Helper function to open mobile menu - use fullscreen version on mobile
    function openMobileMenu() {
      if (isMobile() && typeof window.openMobileFullscreenMenu === 'function') {
        // Use the new fullscreen menu on mobile
        window.openMobileFullscreenMenu();
      } else {
        // Fallback to drawer menu
        if (navbar) navbar.classList.add('open');
        if (menuOverlay) menuOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    }

    // Close menu when clicking overlay
    if (menuOverlay) {
      menuOverlay.addEventListener('click', closeMobileMenu);
    }

    // Handle burger menu toggle
    if (burgerToggle) {
      burgerToggle.addEventListener('change', () => {
        if (burgerToggle.checked) {
          openMobileMenu();
          // Uncheck immediately since fullscreen menu handles its own state
          if (isMobile()) {
            burgerToggle.checked = false;
          }
        } else {
          closeMobileMenu();
        }
      });
    }

    // Close menu with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navbar && navbar.classList.contains('open')) {
        closeMobileMenu();
      }
    });

    // Allow clicking on "Menu" text to open the drawer
    const menuOpenText = document.querySelector('.burger-menu__open');
    if (menuOpenText) {
      menuOpenText.addEventListener('click', () => {
        openMobileMenu();
        if (isMobile()) {
          if (burgerToggle) burgerToggle.checked = false;
        } else {
          if (burgerToggle) burgerToggle.checked = true;
        }
      });
    }

    // Allow clicking on "Cerrar" text to close the drawer
    const menuCloseText = document.querySelector('.burger-menu__close');
    if (menuCloseText) {
      menuCloseText.addEventListener('click', closeMobileMenu);
    }

    // Handle submenu toggles (button click)
    submenuTogglers.forEach(toggler => {
      toggler.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const parentItem = toggler.closest('.navbar__items__item');
        const submenu = parentItem.querySelector('.navbar__submenu');

        if (submenu) {
          submenu.classList.toggle('open');
          toggler.setAttribute('aria-expanded', submenu.classList.contains('open'));
        }
      });
    });

    // Handle wrapper click to expand submenu (mobile only)
    const submenuExpandWrappers = document.querySelectorAll('[data-submenu-expand]');
    submenuExpandWrappers.forEach(wrapper => {
      wrapper.addEventListener('click', (e) => {
        // If user clicked on the link itself, let it navigate
        if (e.target.closest('.navbar__items__link')) {
          return;
        }

        // Otherwise, toggle the submenu
        e.preventDefault();
        e.stopPropagation();

        const parentItem = wrapper.closest('.navbar__items__item');
        const submenu = parentItem.querySelector('.navbar__submenu');
        const toggler = wrapper.querySelector('.plus-minus-toggler');

        if (submenu) {
          submenu.classList.toggle('open');
          if (toggler) {
            toggler.setAttribute('aria-expanded', submenu.classList.contains('open'));
          }
        }
      });
    });
  });

  // ========================================
  // MEGA MENU - Desktop Only
  // ========================================
  (function initMegaMenu() {
    if (window.innerWidth < 1024) return;

    const header = document.querySelector('header.header');
    const megaMenuPanel = document.querySelector('[data-mega-menu-panel]');
    const menuTriggers = document.querySelectorAll('[data-mega-menu-trigger]');

    if (!header || !megaMenuPanel || !menuTriggers.length) return;

    let closeTimeout = null;
    let currentPanel = null;

    function showMegaMenu(handle) {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }

      // Hide all panels first
      const allPanels = megaMenuPanel.querySelectorAll('[data-mega-menu-content]');
      allPanels.forEach(panel => panel.classList.remove('is-active'));

      // Remove active class from all triggers
      menuTriggers.forEach(trigger => trigger.classList.remove('mega-menu-item-active'));

      // Find and show the target panel
      const targetPanel = megaMenuPanel.querySelector(`[data-mega-menu-content="${handle}"]`);

      if (targetPanel) {
        targetPanel.classList.add('is-active');
        megaMenuPanel.classList.add('is-active');
        header.classList.add('mega-menu-active');
        currentPanel = targetPanel;

        // Add active class to trigger
        const activeTrigger = document.querySelector(`[data-mega-menu-trigger="${handle}"]`);
        if (activeTrigger) {
          activeTrigger.classList.add('mega-menu-item-active');
        }
      }
    }

    function hideMegaMenu() {
      closeTimeout = setTimeout(() => {
        megaMenuPanel.classList.remove('is-active');
        header.classList.remove('mega-menu-active');

        const allPanels = megaMenuPanel.querySelectorAll('[data-mega-menu-content]');
        allPanels.forEach(panel => panel.classList.remove('is-active'));

        menuTriggers.forEach(trigger => trigger.classList.remove('mega-menu-item-active'));

        currentPanel = null;
      }, 150);
    }

    function cancelHide() {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    }

    // Menu trigger hover handlers
    menuTriggers.forEach(trigger => {
      const handle = trigger.getAttribute('data-mega-menu-trigger');
      const hasSubmenu = trigger.classList.contains('parent');

      if (hasSubmenu) {
        trigger.addEventListener('mouseenter', () => {
          showMegaMenu(handle);
        });

        trigger.addEventListener('mouseleave', () => {
          hideMegaMenu();
        });
      }
    });

    // Mega menu panel hover handlers
    megaMenuPanel.addEventListener('mouseenter', cancelHide);
    megaMenuPanel.addEventListener('mouseleave', hideMegaMenu);

    // Update image on link hover
    const menuLinks = megaMenuPanel.querySelectorAll('[data-mega-menu-link]');
    menuLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const imageUrl = link.getAttribute('data-image-url');
        if (!imageUrl || !currentPanel) return;

        const imageEl = currentPanel.querySelector('[data-mega-menu-image]');
        if (imageEl && imageEl.tagName === 'IMG') {
          imageEl.classList.add('is-loading');
          const newImg = new Image();
          newImg.onload = () => {
            imageEl.src = imageUrl;
            imageEl.classList.remove('is-loading');
          };
          newImg.src = imageUrl;
        }
      });
    });

    // Close mega menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!header.contains(e.target) && !megaMenuPanel.contains(e.target)) {
        megaMenuPanel.classList.remove('is-active');
        header.classList.remove('mega-menu-active');
        menuTriggers.forEach(trigger => trigger.classList.remove('mega-menu-item-active'));
      }
    });
  })();

  // C5 · buscador colapsado a icono en móvil (plan ficha móvil 28/08/2026). El icono conmuta la
  // clase header--search-open y el CSS hace el resto. Sin JS el enlace va a la página de búsqueda.
  (function () {
    var cabecera = document.querySelector('header.header');
    var icono = document.querySelector('[data-search-toggle]');
    var caja = document.querySelector('[data-header-search]');
    if (!cabecera || !icono || !caja) return;
    icono.addEventListener('click', function (e) {
      e.preventDefault();
      var abierto = cabecera.classList.toggle('header--search-open');
      icono.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      if (abierto) {
        var campo = caja.querySelector('input[type="search"]');
        if (campo) campo.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
